import { makeStyles } from '@mui/styles';

import { Chip } from '@sh4res/bo-common/components/Chip';

type Props = {
  list: string[];
};

const useStyles = makeStyles((theme) => ({
  list: {
    display: 'flex',
    gap: theme.spacing(0.5),
    flexWrap: 'wrap',
  },
}));

export const ChipsList = ({ list }: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.list}>
      {list.map((item: string) => (
        <Chip value={item} key={item} />
      ))}
    </div>
  );
};
